import { DialogMessageViewModel } from '@common/model/dialog/message/dialogMessageViewModel';
import { useCurrentDialogMember } from './useCurrentDialogMember';

export const useDeliveries = (message: DialogMessageViewModel) => {
  const { deliveries } = message;
  const currentMember = useCurrentDialogMember();
  return deliveries.filter((delivery) => delivery.recipientId !== currentMember?.id);
};
